const updateCart = async (attributesObject) => {
  try {
    const update = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: attributesObject
      })
    });

    return await update.json();
  } catch (err) {
    console.error('Update cart error:', err);
  }
};

export default updateCart;
